var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'notice-bar': true, [_vm.type]: true }},[_c('div',{staticClass:"notice-bar-content"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"summary"},[_c('span',[_vm._v(_vm._s(_vm.summary))]),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }